import React from "react";

const HomeIcon = ({className, iconClassName='stroke-black'}) => {
  
   

  return (
    
                
    <div className={`  ${className} `}>
    
      <svg  className={`  ${iconClassName} `} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path stroke="stroke-inherit" strokeLinecap="round" strokeWidth="1" strokeLinejoin="round" d="M9 20H7a2 2 0 0 1-2-2v-7.08a2 2 0 0 1 .698-1.52l5-4.285a2 2 0 0 1 2.604 0l5 4.285A2 2 0 0 1 19 10.92V18a2 2 0 0 1-2 2h-2m-6 0v-6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6m-6 0h6"/>
      </svg>    
                
    </div>       
              
             
           
  );
};

export default HomeIcon;